import { SPRAY_EVENT_TYPE_SET } from './constants';
import { SetSprayEventTypeAction, SprayEventType } from './types';

export function setSprayEventType(
    payload: SprayEventType
): SetSprayEventTypeAction {
    return {
        type: SPRAY_EVENT_TYPE_SET,
        payload
    };
}
